// import React from "react";
// import { useTranslation } from "react-i18next";
// import { Link, useLocation } from "react-router-dom";

// export default function BreadCrumb() {
//   const location = useLocation();
//   const { t } = useTranslation();

//   const growerId = location?.state?.GrowerId?.id;
//   const pathnames = location.pathname.split("/").filter((x) => x);
//   return (
//     <span className="page-heading">
//       {pathnames?.map((item, index) => {
//         const to = `/${pathnames.slice(0, index + 1).join("/")}`;
//         if (index > 1) {
//           return (
//             index > 1 && (
//               <span className="custom_breadcrumb">
//                 <span className="slash_text">/</span>
//                 <span className="breadcrumb_text">
//                   <Link state={{ key: growerId }} to={to}>
//                     {t(item.replace(/-/g, " "))}
//                   </Link>
//                 </span>
//               </span>
//             )
//           );
//         } else if (index === 1) {
//           return (
//             <span className="page_heading_title">
//               <Link state={{ key: growerId }} to={to}>
//                 {t(item.replace(/-/g, " "))}
//               </Link>{" "}
//             </span>
//           );
//         }
//         return null;
//       })}
//     </span>
//   );
// }
import React from "react";
import { useTranslation } from "react-i18next";
import { Link, useLocation } from "react-router-dom";

export default function BreadCrumb() {
  const location = useLocation();
  const { t } = useTranslation();

  const growerId = location?.state?.GrowerId?.id;

  // Extract path from the hash: "#/web/login" → "/web/login"
  const hashPath = location.hash.startsWith("#")
    ? location.hash.slice(1)
    : location.pathname;

  const pathnames = hashPath.split("/").filter((x) => x);

  return (
    <span className="page-heading">
      {pathnames.map((item, index) => {
        const to = `/${pathnames.slice(0, index + 1).join("/")}`;
        const label = t(item.replace(/-/g, " "));

        if (index > 1) {
          return (
            <span key={index} className="custom_breadcrumb">
              <span className="slash_text">/</span>
              <span className="breadcrumb_text">
                <Link state={{ key: growerId }} to={to}>
                  {label}
                </Link>
              </span>
            </span>
          );
        } else if (index === 1) {
          return (
            <span key={index} className="page_heading_title">
              <Link state={{ key: growerId }} to={to}>
                {label}
              </Link>{" "}
            </span>
          );
        }
        return null;
      })}
    </span>
  );
}
